"use client";
import { motion, useScroll } from "framer-motion";

export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  
  return (
    <motion.div
      className="absolute bottom-0 left-0 right-0 h-[4px] bg-accent z-[1001] origin-left shadow-[0_0_10px_2px_rgba(222,204,164,0.8)]"
      style={{ scaleX: scrollYProgress, backgroundColor: "var(--accent-color)" }}
    />
  );
}